"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GiveawayStatsToJSON = exports.GiveawayStatsFromJSONTyped = exports.GiveawayStatsFromJSON = exports.instanceOfGiveawayStats = void 0;
var runtime_1 = require("../runtime");
var GiveawayStatsGrowth_1 = require("./GiveawayStatsGrowth");
/**
 * Check if a given object implements the GiveawayStats interface.
 */
function instanceOfGiveawayStats(value) {
    var isInstance = true;
    isInstance = isInstance && "entryCount" in value;
    isInstance = isInstance && "participantCount" in value;
    return isInstance;
}
exports.instanceOfGiveawayStats = instanceOfGiveawayStats;
function GiveawayStatsFromJSON(json) {
    return GiveawayStatsFromJSONTyped(json, false);
}
exports.GiveawayStatsFromJSON = GiveawayStatsFromJSON;
function GiveawayStatsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'entryCount': json['entryCount'],
        'participantCount': json['participantCount'],
        'growth': !(0, runtime_1.exists)(json, 'growth') ? undefined : (0, GiveawayStatsGrowth_1.GiveawayStatsGrowthFromJSON)(json['growth']),
    };
}
exports.GiveawayStatsFromJSONTyped = GiveawayStatsFromJSONTyped;
function GiveawayStatsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'entryCount': value.entryCount,
        'participantCount': value.participantCount,
        'growth': (0, GiveawayStatsGrowth_1.GiveawayStatsGrowthToJSON)(value.growth),
    };
}
exports.GiveawayStatsToJSON = GiveawayStatsToJSON;
